export const CREATE_CUSTOM_FIELD = 'CREATE_CUSTOM_FIELD';
export const CREATE_CUSTOM_FIELD_RESULT = 'CREATE_CUSTOM_FIELD_RESULT';
export const UPDATE_CUSTOM_FIELD = 'UPDATE_CUSTOM_FIELD';
export const UPDATE_CUSTOM_FIELD_RESULT = 'UPDATE_CUSTOM_FIELD_RESULT';
export const UPDATE_CUSTOM_FIELD_ORDER = 'UPDATE_CUSTOM_FIELD_ORDER';
export const UPDATE_CUSTOM_FIELD_ORDER_RESULT = 'UPDATE_CUSTOM_FIELD_ORDER_RESULT';
export const UPDATE_CUSTOM_FIELD_VALUES = 'UPDATE_CUSTOM_FIELD_VALUES';
export const UPDATE_USER_CUSTOM_FIELD_VALUES_RESULT = 'UPDATE_USER_CUSTOM_FIELD_VALUES_RESULT';
export const UPDATE_ADMIN_CUSTOM_FIELD_VALUES = 'UPDATE_ADMIN_CUSTOM_FIELD_VALUES_RESULT';
export const UPDATE_ADMIN_CUSTOM_FIELD_VALUES_RESULT = 'UPDATE_ADMIN_CUSTOM_FIELD_VALUES_RESULT';
export const CLEAR_CUSTOM_FIELD_RESULTS = 'CLEAR_CUSTOM_FIELD_RESULTS';
export const UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE = 'UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE';
export const UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE_RESULT =
  'UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE_RESULT';
export const PROCESS_PHANTOM_INVITE_CUSTOM_FIELDS = 'PROCESS_PHANTOM_INVITE_CUSTOM_FIELDS';

export const CUSTOM_FIELD_STATES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ARCHIVED: 'archived',
} as const;
